import IntroJs from 'intro.js'
import 'intro.js/introjs.css'

export const steps_home_page = {
  id:'steps_home_page_id_02',
  steps : [
  {
    element:'#c-app-search-bar',
    title:'搜索',
    intro:'此处可以搜索菜单、问答、资讯、功能说明等',
    position:'bottom'
  },
  {
    element:'#c-board-item-user-info',
    title:'我的待办',
    intro:'此处是待审批的待办，按业务类型展示待办数量。\n点击对应模块可以进入详情页面处理。',
    position:'bottom'
  },
  {
    element:'#c-data-board',
    title:'数据简报',
    intro:'此处展示常用的数据报表，可以点击全部查看更多报表。\n同事可以点击里面的编辑将数据模块移动到首页',
    position:'bottom'
  },
  {
    element:'#c-board-card',
    title:'我的审批',
    intro:'待审批的单据都会展示在此处，需要重点关注。',
    position:'bottom'
  }
]}
export const steps_home_menu = {
  id:'steps_home_page_id_01',
  steps : [
  {
    element:'#c-app-menu-favorite-action-icon',
    title:'收藏菜单',
    intro:'点击此处可收藏菜单',
    position:'bottom'
  },

    {
      element:'#app-header-left-icon',
      title:'收藏夹',
      intro:'点击此处查看收藏夹',
      position:'bottom'
    },
  {
    element:'#c-app-menu-more-action',
    title:'查看功能说明',
    intro:'点击此处可查看此功能的使用说明',
    position:'bottom'
  }
]}

export const introJsCheckStart = async (steps:any) => {

  const stepId = localStorage.getItem(steps.id)
  if(stepId){
    return
  }

  const currIntro = IntroJs()
  currIntro.setOptions({
    prevLabel: '上一步',
    nextLabel: '下一步',
    // skipLabel: '跳过',
    doneLabel: '我知道了',
    tooltipPosition: 'bottom',
    hidePrev: true, // 隐藏第一步中的上一个按钮
    tooltipClass: '' /* 引导说明文本框的样式 */,
    highlightClass: '' /* 说明高亮区域的样式 */,
    exitOnOverlayClick: false /* 是否允许点击空白处退出 */,
    showStepNumbers: false /* 是否显示说明的数据步骤*/,
    keyboardNavigation: false /* 是否允许键盘来操作 */,
    showButtons: true /* 是否按键来操作 */,
    showBullets: true /* 是否使用点点点显示进度 */,
    showProgress: false /* 是否显示进度条 */,
    scrollToElement: true /* 是否滑动到高亮的区域 */,
    overlayOpacity: 0.6 /* 遮罩层的透明度 */,
    positionPrecedence: ['bottom', 'top', 'right', 'left'] /* 当位置选择自动的时候，位置排列的优先级 */,
    disableInteraction: true, /* 是否禁止与元素的相互关联 */
    hintPosition: 'top-middle',
    steps: steps.steps
  })
  currIntro.oncomplete(() => {
    // 点击结束按钮后执行的事件
    console.log(`oncomplete`)
    localStorage.setItem(steps.id,steps.id)
  })
  currIntro.onexit(() => {
    // 点击跳过按钮后执行的事件
    console.log(`onexit`)
    localStorage.setItem(steps.id,steps.id)
  })
  currIntro.onchange(() => {
    // 点击下一步执行的事件
    console.log(`onchange`)
  })
  await currIntro.start()
}
